function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 18c4.924 0 9-4.085 9-9 0-4.924-4.085-9-9.009-9C4.076 0 0 4.076 0 9c0 4.915 4.085 9 9 9zm-3.115-5.153a.736.736 0 01-.511-1.253L7.959 9.01 5.374 6.424a.744.744 0 01-.212-.512c0-.406.326-.724.723-.724.212 0 .38.07.512.212l2.594 2.585 2.62-2.594c.15-.15.31-.22.504-.22.397 0 .723.326.723.723a.706.706 0 01-.211.52L10.031 9.01l2.586 2.576c.14.15.211.318.211.52a.738.738 0 01-.732.742.757.757 0 01-.52-.22L8.99 10.04l-2.567 2.585a.746.746 0 01-.539.221z",
  fill: "currentColor"
});

function SvgDeleteXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgDeleteXIcon;